<template>
    <div class="row">
        <div class="col">
            <search></search>
            <result></result>
            <back-to-top></back-to-top>
        </div>
    </div>
</template>

<script>
    import Result from './activity-profiles/Result'
    import Search from './activity-profiles/Search'

    export default {
    
        components: {
            Search, Result
        }
    }
</script>
